module.exports = __webpack_public_path__ + "img/20221110114144314dx8.404f2d7c.jpg";